export class StatusEndTimeRules {
  categoryId: number;
  cEndTime: string;
  nEndTime: number;
  statusId: number;
  regionId: number;
  regionName: string;
  categoryName: string;
  statusDescription: string;

  constructor(json?: any) {
    if (!json) {
      return;
    }

    this.categoryId = json.categoryId;
    this.cEndTime = json.cEndTime;
    this.nEndTime = json.nEndTime;
    this.statusId = json.statusId;
    this.regionId = json.regionId;
    this.regionName = json.regionName;
    this.categoryName = json.categoryName;
    this.statusDescription = json.statusDescription;
  }
}



// WEBPACK FOOTER //
// E:/proj/news12/zb-n12/scadmin/client/src/app/shared/models/StatusEndTimeRules.ts